import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { catchError, Observable, of } from 'rxjs';
import { Tenant } from '@org/interfaces';
import { TenantService } from '@org/shared-services';

@Component({
    selector: 'app-tenant-list',
    imports: [CommonModule],
    templateUrl: './tenantList.component.html',
    styleUrl: './tenantList.component.css'
})
export class TenantListComponent implements OnInit {
  tenants$!: Observable<Tenant[]>;
  totalTenants$: Observable<number>;
  tenantCount: number = 0;
  childShops$!: Observable<any[]>; // Observable for child shops
  selectedTenantId: string | null = null; // To track selected tenant

  constructor(private tenantService: TenantService, private cdr: ChangeDetectorRef,) {
    this.tenants$ = this.tenantService.tenants$;
    this.totalTenants$ = this.tenantService.totaltenants$;
  }


  ngOnInit() {
    this.tenantService.getCorporateTenants();
    this.totalTenants$.subscribe(total => {
      this.tenantCount = total;
    });

    this.tenants$.subscribe({
      next: (tenants) => {
        this.cdr.detectChanges(); // Trigger change detection
      },
      error: () => { }
    });
  }

  loadChildShops(parentTenantId: any): void {
    if (this.selectedTenantId === parentTenantId) {
      // If the same tenant is clicked again, hide the shops
      this.selectedTenantId = null;
      this.childShops$ = of([]); // Reset the observable
    } else {
      // If a new tenant is selected, load child shops
      this.selectedTenantId = parentTenantId;
      this.childShops$ = this.tenantService.getLocationsByCorporation().pipe(
        catchError(error => {
          console.error('Error loading child shops:', error);
          return of([]); // Return empty array on error
        })
      );
    }
  }
  
}
